import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { AdminRoute, AuthCallback, ProtectedRoute } from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import MapPage from "@/pages/MapPage";
import LiveMapPage from "@/pages/LiveMap";
import LiveCoverage from "@/pages/LiveCoverage";
import PortEmissions from "@/pages/PortEmissions";
import Home from "@/pages/Home";
import LiveVesselDetail from "@/pages/LiveVesselDetail";
import { SensorsPage, StationDetail } from "@/pages/Sensors";
import { VesselDetail, VesselsPage } from "@/pages/Vessels";
import EventsPage from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Investigations from "@/pages/Investigations";
import AdminPage from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  // Session exchange must run before any protected route checks /auth/me.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Navigate to="/dashboard" replace />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/map" element={<LiveMapPage />} />
        <Route path="/map/replay" element={<MapPage />} />
        <Route path="/live/coverage" element={<LiveCoverage />} />
        <Route path="/port-emissions" element={<PortEmissions />} />
        <Route path="/live/vessels/:mmsi" element={<LiveVesselDetail />} />
        <Route path="/sensors" element={<SensorsPage />} />
        <Route path="/sensors/:stationId" element={<StationDetail />} />
        <Route path="/vessels" element={<VesselsPage />} />
        <Route path="/vessels/:vesselId" element={<VesselDetail />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:eventId" element={<EventDetail />} />
        <Route path="/investigations" element={<Investigations />} />
        <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#11241C", border: "1px solid #1E3E30", color: "#e2e8f0" } }} />
      </AuthProvider>
    </BrowserRouter>
  );
}
